import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    controller: null, // start as null, will be replaced with API data
};

export const controllerRedux = createSlice({
    name: "controller",
    initialState,
    reducers: {
        updateController: (state, action) => {
            if (action?.payload) {
                state.controller = action.payload; // set API data
            }
        },
    },
});

export const { updateController } = controllerRedux.actions;
export default controllerRedux.reducer;
